// Utility functions for time formatting and calculations

/**
 * Formats seconds into a human-readable time display (HH:MM:SS)
 * @param {number} seconds - The number of seconds to format
 * @returns {string} - Formatted time string
 */
export const formatTimeDisplay = (seconds) => {
  if (!seconds && seconds !== 0) return '00:00:00';
  
  // Calculate hours, minutes, and remaining seconds
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);
  
  // Format with leading zeros
  const formattedHours = String(hours).padStart(2, '0');
  const formattedMinutes = String(minutes).padStart(2, '0');
  const formattedSeconds = String(secs).padStart(2, '0');
  
  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};

/**
 * Calculates the elapsed time in seconds between a start time and now
 * @param {string} startTime - ISO string representing the start time
 * @returns {number} - Elapsed time in seconds
 */
export const calculateElapsedSeconds = (startTime) => {
  if (!startTime) return 0;
  
  const start = new Date(startTime).getTime();
  const now = Date.now();
  
  const elapsed = Math.floor((now - start) / 1000);
  console.log("calculateElapsedSeconds:", start, now, elapsed);
  return elapsed;
};

/**
 * Formats a duration in minutes into a readable format
 * @param {number} durationMinutes - Duration in minutes
 * @returns {string} - Formatted duration string
 */
export const formatDuration = (durationMinutes) => {
  if (!durationMinutes && durationMinutes !== 0) return '0m';
  
  const hours = Math.floor(durationMinutes / 60);
  const minutes = durationMinutes % 60;
  
  if (hours === 0) {
    return `${minutes}m`;
  } else if (minutes === 0) {
    return `${hours}h`;
  } else {
    return `${hours}h ${minutes}m`;
  }
};

/**
 * Formats a date for display
 * @param {string} dateString - ISO date string
 * @returns {string} - Formatted date string
 */
export const formatDate = (dateString) => {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });
};